import 'bootstrap'
import '../Styles/entrypoint.scss'
import '../../../../packages/Utils/Scripts/entrypoint'
import { initFlatpickrRangeDate, initFlatpickrRangeDateTime } from '../../AdminModule/Scripts/_Flatpickr'

import('../../AdminModule/Components/SharedComponents/AnnouncementFormControl/Scripts/AnnouncementFormControl')
import('../../AdminModule/Components/SharedComponents/EntryRequestFormControl/Scripts/EntryRequestFormControl')

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('announcement-send-form-control-file-pond')) {
        import('../Components/Announcement/AnnouncementSendFormControl/AnnouncementSendFormControl')
    }

    if (document.getElementById('frm-researchDetail-researchDetailMapForm-researchDetailMapForm')) {
        import('../../AdminModule/Components/SharedComponents/ResearchDetailMapFormControl/Scripts/ResearchDetailMapFormControl')
    }


    document.querySelectorAll<HTMLElement>('.flatpickr-range-datetime').forEach(element => {
        initFlatpickrRangeDateTime(element)
    })
    document.querySelectorAll<HTMLElement>('.flatpickr-range-date').forEach(element => {
        initFlatpickrRangeDate(element)
    })
})